import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // model
  fileModel: [],
  tenantModel: [],

  // fileType
  // string or array
  fileType: '',

  // 検索
  filters: {
    searchFileName: null,
    searchTenant: '',
  },

  //form
  serviceId: null,
  buttonId: null,
  index: 0,

  // 選択されたファイル情報
  value: null
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}, {serviceId, buttonId, index, fileType}) {
		// cover
		this.dispatch('core/showModalCover')
		
    commit('setServiceId', serviceId)
    commit('setButtonId', buttonId)
    if (index !== undefined) {
      commit('setIndex', index)
    }
    commit('setFileType', fileType)
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {fileParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'file',
          'tenant'
        ],
        [
          'v1FileListGet',
          'v1TenantListGet'
        ],
        [
          fileParams,
          {}
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setFileModel', res[0].data.files)
            commit('setTenantModel', res[1].data.tenants)
            console.log('fileModel', state.fileModel)
            console.log('tenantModel', state.tenantModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * ファイル一覧を読出し
   */
  loadFileList ({commit}, {fileParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['file',],
        ['v1FileListGet',],
        [fileParams,])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setFileModel', res[0].data.files)
            console.log('fileModel', state.fileModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          reject(null)
        })
    })
  },

  /**
   * 選択されたファイル情報を保持
   */
  setValue ({commit}, data) {
    commit('setValue', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  setFileModel (state, data) {
    Vue.set(state, 'fileModel', data)
  },
  setTenantModel (state, data) {
    Vue.set(state, 'tenantModel', data)
  },

  setInputFilter (state, {key, value}) {
    Vue.set(state.filters, key, value)
  },
  
  // form
  setServiceId (state, id) {
    state.serviceId = id
  },
  setButtonId (state, id) {
    state.buttonId = id
  },
  setIndex (state, index) {
    state.index = index
  },
  setFileType (state, type) {
    state.fileType = type
  },
  setValue (state, data) {
    Vue.set(state, 'value', data)
  },

  // reset
  reset (state) {
    Vue.set(state, 'fileModel', [])
    Vue.set(state, 'value', null)
    Vue.set(state, 'filters', {
      searchFileName: null,
      searchTenant: '',
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
